import { useCallback, useEffect } from "react";

const MESSAGE = "You have unsaved changes. Leave this page without saving?";

/**
 * Guards a form against losing work: warns on reload/close, and returns a
 * confirm helper for in-app links so a stray click can't discard edits.
 */
export default function useUnsavedGuard(dirty) {
  useEffect(() => {
    if (!dirty) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [dirty]);

  return useCallback(
    (e) => {
      if (!dirty) return true;
      if (window.confirm(MESSAGE)) return true;
      e?.preventDefault();
      e?.stopPropagation();
      return false;
    },
    [dirty]
  );
}
